import { render, staticRenderFns } from "./Tester.vue?vue&type=template&id=5f9f2f5c&scoped=true&"
import script from "./Tester.vue?vue&type=script&lang=js&"
export * from "./Tester.vue?vue&type=script&lang=js&"
import style0 from "./Tester.vue?vue&type=style&index=0&id=5f9f2f5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9f2f5c",
  null
  
)

export default component.exports